<template>
  <div class="d-currency" @click.stop="showItemList()">
    <p>{{ currency }}</p>
    <img alt="" src="@/assets/imgs/triangle.png" v-if="isEditMode" class="sm-close" disabled>
    <slide-x-left-transition>
      <div class="d-active" :class="{bottom: position === 'bottom'}" v-show="curShowList === 'currency'">
        <div class="menu">
          <div class="m-item" @click.stop="callFn('callback', item)" v-for="(item, i) in list" :key="i">
            <div class="c">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </slide-x-left-transition>
  </div>
</template>

<script>
import CurrencyInfo from "@/assets/models/CurrencyInfo";

export default {
  data() {
    return {
      list: CurrencyInfo.currencys()
    };
  },
  props: ['callback', 'position', 'curShowList', 'currency', 'isEditMode'],
  methods: {
    showItemList() {
      this.isEditMode && this.$parent.$parent.showItemList('currency', true)
    },
    callFn(fnName, param) {
      this[fnName] && this[fnName].call(this, param)
    }
  },
};
</script>
<style scoped>
.bottom {
  align-items: flex-start;
}

.m-item {
  padding: 3px 0;
}

.d-currency {
  display: flex;
  flex-direction: row;
  width: auto;
  border: 1px solid #dfe1e6;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  height: 25px;
  line-height: 25px;
  border-radius: 3px;
  margin: 0 6px;
  cursor: pointer;
  position: relative;
}

.d-currency p {
  white-space: nowrap;
}

.sm-close {
  margin-left: 5px;
  position: relative;
  top: 1px;
}
</style>
